import * as swcHelpers from '@swc/helpers';
import { resilientFetch } from '@grandvisionhq/utils';

const fetch = resilientFetch();
const userAgentHeader = 'GV-eCom-FE';
function brHttpClient(options) {
    return _brHttpClient.apply(this, arguments);
}
function _brHttpClient() {
    _brHttpClient = swcHelpers.asyncToGenerator(function*(options) {
        const { url , data , headers: originalHeaders  } = options, rest = swcHelpers.objectWithoutProperties(options, [
            "url",
            "data",
            "headers"
        ]);
        const headers = swcHelpers.objectSpread({}, originalHeaders, {
            'User-Agent': userAgentHeader
        });
        const response = yield fetch(url, swcHelpers.objectSpread({}, rest, {
            headers,
            body: data
        }));
        // Some of the error responses actually contain html instead of json
        // This makes sure we don't actually try to parse html as json
        const contentType = response === null || response === void 0 ? void 0 : response.headers.get('content-type');
        if (!(contentType === null || contentType === void 0 ? void 0 : contentType.includes('application/json'))) {
            throw new Error(`Expected Bloomreach response type to be 'application/json' but got '${contentType}' instead`);
        }
        const json = yield response.json();
        return {
            data: json
        };
    });
    return _brHttpClient.apply(this, arguments);
}

export { brHttpClient, userAgentHeader };
//# sourceMappingURL=http-client.js.map
